export default "__VITE_ASSET__CM4wNGm0__"